// mixin.js
import { mapState} from 'vuex';

export default {
    methods: {
        getStaticImage(image) {
            return window.cordova ? ("file:./img/" + image.substring(image.lastIndexOf('/') + 1)) : require("@/assets/img/" + image);
        },
    },
    computed: {
        ...mapState("user", ["user"]),
    }
};
